import React, { useMemo } from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { useWidth } from '@tmap/mmm-style-guide/src/useWidth';

import ContributionCard from './contributionCard';
import TextTestimonial from './textTestimonial';
import SuggestedTopicsCard from './suggestedTopicsCard';
import SubmitPostCTACard from './submitPostCtaCard';

const PostGridItems = (props) => {
  const {
    posts,
    testimonials,
    suggestedTopics,
    community,
    onPostClick,
    numPages = 1,
    pageId,
  } = props;
  const width = useWidth() ?? 'lg';

  const cardsToDisplay = [...useMemo(() => posts.map((post, i) => (
    <Grid item xs={12} sm={6} md={4} key={`post-grid-${post._id}`}>
      <ContributionCard
        contribution={post}
        entityUrl={`/c/${post.slug}`}
        key={`contributionCard-${post._id}`}
        pageId={pageId}
        placementId={`post-${i}`}
      />
    </Grid>
  )), [posts, pageId])];

  if (testimonials?.length) {
    testimonials.forEach((testimonial, i) => {
      if (i < numPages) {
        // splice in one testimonial in the 2-5th position of each page
        const position = (i % 4) + 1 + (i * 6);
        cardsToDisplay.splice(
          position,
          0,
          (
            <Grid item xs={12} sm={6} md={4} key={`post-grid-testimonial-${testimonial?._key || `loading-${i}`}`}>
              <TextTestimonial locationText={community.locationText} testimonial={testimonial} />
            </Grid>
          ),
        );
      }
    });
  }
  if (suggestedTopics) {
    const topicsPerCard = 7;
    suggestedTopics.sort((a, b) => b.count - a.count);
    const suggestedTopicsGroups = new Array(Math.ceil(suggestedTopics.length / topicsPerCard))
      .fill().map((x, i) => (
        suggestedTopics.slice(i * topicsPerCard, (i + 1) * topicsPerCard)
      ));
    suggestedTopicsGroups.forEach((group, i) => {
      const position = 5 + (i * 6);
      if (position <= cardsToDisplay.length) {
        cardsToDisplay.splice(
          position,
          0,
          (
            <Grid item xs={12} sm={6} md={4} key={`post-grid-suggested-topics-${i}`}>
              <SuggestedTopicsCard suggestedTopics={group} communityUrl={`/moving-living/${community.slug.current}`} />
            </Grid>
          ),
        );
      }
    });
  }

  if (onPostClick && cardsToDisplay.length < 6) {
    cardsToDisplay.push((
      <Grid item xs={12} sm={6} md={4} key='post-grid-cta'>
        <SubmitPostCTACard onPostClick={onPostClick} />
      </Grid>
    ));
  }

  // eslint-disable-next-line no-nested-ternary
  const trimIncrement = width === 'xs' ? 1 : (width === 'sm' ? 2 : 3);
  // extra content is content exceeding 6 items that is not in increments of 3
  const trimExtraContent = Math.max(
    6,
    cardsToDisplay.length - (cardsToDisplay.length % trimIncrement),
  );
  return cardsToDisplay.slice(0, trimExtraContent);
};

export default PostGridItems;
